export default __webpack_public_path__ + "static/media/pic2.34f73e51.jpg";